import { Box, Switch, Typography } from "@mui/material"
import { styles } from "./SwitchLabel.styles"
import { useTranslation } from "react-i18next"

export const SwitchLabelUi = ({
  checked,
  onChange,
  disabled = false,
  showLabel = true,
}) => {
  const { t } = useTranslation()
  return (
    <Box sx={styles.rightBlock}>
      <Switch
        focusVisibleClassName=".Mui-focusVisible"
        disableRipple
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        sx={styles.switch}
      />
      {showLabel && (
        <Typography variant="body2" sx={styles.switchLabel}>
          {checked ? t("on", "On") : t("off", "Off")}
        </Typography>
      )}
    </Box>
  )
}
